import * as React from 'react';
import { baseUniDriverFactory } from '../testkitUtils/unidriver';
import { uniDriverImplementation } from './unidriver-config';
import { createRendererWithUniDriver } from './utils';
import { getAsyncElementFinder } from './unidriver-mixins';

describe('getAsyncElementFinder', () => {
  const render = createRendererWithUniDriver((base, body) => ({
    ...baseUniDriverFactory(base),
    base,
    body,
  }));

  it('driver baseline when element does not exist', async () => {
    const { driver } = render(
      <div id="base" data-hook="base">
        something
      </div>,
    );

    const notFound = driver.base.$('notFound');

    expect(await notFound.exists()).toBe(false);
    await expect(notFound.getNative()).rejects.toThrow();
    await expect(notFound.$('whatever').getNative()).rejects.toThrow();
  });

  it('should async element finder that resolves to falsy value silently break driver behaviour', async () => {
    const bad = uniDriverImplementation.current(async () => undefined);

    expect(await bad.exists()).toBe(true);
    await expect(bad.getNative()).resolves.toBe(undefined);
    await expect(bad.$('whatever').getNative()).rejects.toThrow();
  });

  it('should async element finder that throws/rejects behave as element parameter', async () => {
    const { driver } = render(
      <div id="base" data-hook="base">
        something
      </div>,
    );

    const notFound = driver.base.$('notFound');
    const good = uniDriverImplementation.current(async () =>
      getAsyncElementFinder(notFound),
    );

    expect(await good.exists()).toBe(false);
    await expect(good.getNative()).rejects.toThrow();
    await expect(good.$('whatever').getNative()).rejects.toThrow();
  });
});
